import { LitElement, html } from 'lit';
import styles from './styles';
import AppContextConsumer from '../../../shared/context/app-context/AppContextConsumer';
import '../../../shared/components/icons/IconFacebook';
import '../../../shared/components/icons/IconLinkedIn';
import '../../../shared/components/icons/IconTwitter';
import '../../../shared/components/icons/IconYoutube';
import '../partners-login/PartnersLogin';
import '../partners-registration/PartnersRegistration';

class PartnersPage extends LitElement {
  static styles = styles;

  static properties = {
    activeContainer: {
      type: String,
      state: true,
    },
    type: { type: String },
  };

  context = AppContextConsumer(this);

  constructor() {
    super();
    this.activeContainer = this.#getActiveContainer();
    this.type = 'partners';
  }

  async #setActiveContainer(activeContainer) {
    this.activeContainer = activeContainer;
  }

  #getActiveContainer() {
    const locationHash = window.location.hash.substring(1);
    const activeContainer = (locationHash === 'register' || locationHash === 'login') ? locationHash : 'register';
    return activeContainer;
  }

  connectedCallback() {
    super.connectedCallback();
    this.activeContainer = this.#getActiveContainer();
  }

  render() {
    return html`
      <div class="partners-page-container">
        <div class="partners-page-header">
          <li class="list-inline-item">
            <span id="partner-menu-register" class="menu-link ${this.activeContainer !== 'register' ? 'hidden-container' : ''}">
              <a id="partner-register-link" href="#register" @click="${() => this.#setActiveContainer('register')}">Register</a>
              <svg class="menu-icon" width="36px" height="36px" fill="#1E2426" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 24 24" xml:space="preserve">
                <style type="text/css">
                  .st0{fill:none;}
                </style>
                <path d="M18.5,15.5l-6-7l-6,7H18.5z"/>
                <rect class="st0" width="24" height="24"/>
                <rect class="st0" width="24" height="24"/>
              </svg>
            </span>
            <span id="partner-menu-login" class="menu-link ${this.activeContainer !== 'login' ? 'hidden-container' : ''}">
              <a id="partner-login-link" href="#login" @click="${() => this.#setActiveContainer('login')}">Partner Login</a>
              <svg class="menu-icon" width="36px" height="36px" fill="#1E2426" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 24 24" xml:space="preserve">
                <style type="text/css">
                  .st0{fill:none;}
                </style>
                <path d="M18.5,15.5l-6-7l-6,7H18.5z"/>
                <rect class="st0" width="24" height="24"/>
                <rect class="st0" width="24" height="24"/>
              </svg>
            </span>
          </li>
        </div>
        ${this.activeContainer === 'login' ? html`<tenable-partners-login></tenable-partners-login>` : ''}
        ${this.activeContainer === 'register' ? html`<tenable-partners-registration type=${this.type}></tenable-partners-registration>` : ''}
      </div>
    `;
  }
}

customElements.define('tenable-partners-page', PartnersPage);
